import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'

/**
 * Presenting section component
 * Features: Animated content reveal, image showcase, feature highlights
 */
const Presenting = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-50px" })

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { y: 30, opacity: 0, background: 'transparent' },
    visible: {
      y: 0,
      opacity: 1,
      background: 'transparent',
      transition: {
        duration: 0.4,
        ease: "easeOut"
      }
    }
  }


  return (
    <section 
      id="presenting" 
      className="relative min-h-screen overflow-hidden" 
      style={{ 
        position: 'relative', 
        zIndex: 5,
        backgroundImage: `url('/yellow-bg.svg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }} 
      ref={ref}
    >
      <div style={{ 
        maxWidth: '1280px', 
        margin: '0 auto',
        padding: '64px 16px'
      }}>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {/* Section Header */}
          <motion.div className="text-left mb-16" variants={itemVariants}>
            <h2 
              className="text-6xl md:text-7xl font-bold mb-8"
              style={{ 
                fontFamily: 'Sequel100-65, sans-serif',
                color: '#000000',
                textTransform: 'uppercase',
                lineHeight: '1.1'
              }}
            >
              Presenting
            </h2>
          </motion.div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
            {/* Left Content */}
            <motion.div variants={itemVariants}>
              {/* OlinPoker Logo/Badge */}
              <div 
                className="inline-block px-6 py-3 mb-8 rounded-lg"
                style={{ 
                  backgroundColor: '#000000',
                  color: '#E5FF47'
                }}
              >
                <h3 
                  className="text-xl font-bold"
                  style={{ 
                    fontFamily: 'Sequel100-65, sans-serif',
                    margin: 0
                  }}
                >
                  OlinPoker
                </h3>
              </div>

              {/* Main Description */}
              <h4 
                className="text-2xl md:text-3xl font-bold mb-6"
                style={{ 
                  fontFamily: 'Sequel100-65, sans-serif',
                  color: '#000000',
                  lineHeight: '1.3'
                }}
              >
                OlinPoker is The First DeFi SaaS Poker Platform that enables Club Owners to manage their poker club.
              </h4>

              <div className="space-y-4 text-black">
                <p 
                  className="text-lg leading-relaxed"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  By using OlinPoker&apos;s decentralized finance, professional tools and analytics, you will be managing your club autonomously and privately. Making more informed management decisions leading to increased profit and business growth. OlinPoker tracks dozens of data points and gives an instant overview of every game, player and hand.
                </p>
                <p 
                  className="text-lg leading-relaxed"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Our Poker Club&apos;s Manager system allows you to analyze the action and look at the smallest details to give you the information you need to make appropriate tweaks for the next game.
                </p>
              </div>
            </motion.div>

            {/* Right Platform Image */}
            <motion.div className="relative" variants={itemVariants}>
              <div className="relative">
                <img 
                  src="/desktop_Onlinepoker.png" 
                  alt="OlinPoker Platform Interface" 
                  className="mx-auto"
                  style={{ 
                    maxWidth: '100%',
                    height: 'auto',
                    filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.3))'
                  }}
                />
              </div>
            </motion.div>
          </div>

        </motion.div>
      </div>
    </section>
  )
}

export default Presenting
